export default __webpack_public_path__ + "static/media/LogoN.ba56b513.svg";